import { ElementType } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Picture, PictureProps } from "@/components/wpl/image/src";
import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export type FeaturedInfoCardProps = {
    readonly Icon?: ElementType<IconSvgProps>;
    readonly iconSize?: string;
    readonly title: string;
    readonly body?: string;
    readonly image?: PictureProps;
};

const containerStyles = css({
    "containerType": "inline-size",
    "width": "100%",
    "height": "100%",
    "@container (width > 48rem)": {
        "> div": {
            "flexDirection": "row",
            "alignItems": "stretch",
            ".image": {
                flex: 7,
                width: "auto"
            },
            ".body": {
                flex: 5,
                justifyContent: "center"
            }
        }
    }
});
const cardStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "flexShrink": "0",
    "borderRadius": `${token("space.100")}`,
    "width": "100%",
    "height": "100%",
    "overflow": "clip",

    ".image": {
        lineHeight: 0
    },

    "p, h3": {
        margin: 0,
        lineHeight: 1.25
    }
});
const cardBodyStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "padding": `${token("space.400")}`,
    "alignItems": "flex-start",
    "gap": "10px",
    "flexShrink": "0",
    "borderRadius": `${token("space.100")}`,
    "background": "#fff",

    "p, h3": {
        margin: 0,
        lineHeight: 1.25
    },
    "p": {
        lineHeight: "1.5rem"
    }
});

export const FeaturedInfoCard = ({
    Icon,
    title,
    body,
    iconSize = "24",
    image
}: FeaturedInfoCardProps) => {
    return (
        <div css={containerStyles}>
            <div css={cardStyles}>
                {image && (
                    <div className="image">
                        <Picture {...image} />
                    </div>
                )}
                <div css={cardBodyStyles} className="body">
                    {Icon && (
                        <div>
                            <Icon size={iconSize} />
                        </div>
                    )}
                    <h3 className="h4">{title}</h3>
                    {body && <p>{body}</p>}
                </div>
            </div>
        </div>
    );
};
